import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "radio-checked",
  "use": "radio-checked-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" id=\"radio-checked\"><circle fill=\"transparent\" stroke=\"#adadad\" cx=\"7.5\" cy=\"7.5\" r=\"7\" /><circle fill=\"#262626\" cx=\"7.5\" cy=\"7.5\" r=\"3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol